import { useState, useEffect } from 'react'
import { supabase } from '../lib/supabase'

export function useBriefingStats() {
  const [stats, setStats] = useState(null)

  useEffect(() => {
    let cancelled = false
    async function load() {
      try {
        const today = new Date().toISOString().split('T')[0]
        const [projetos, atrasadas, hoje] = await Promise.all([
          supabase.from('projetos').select('id', { count: 'exact', head: true }),
          supabase.from('tarefas').select('id', { count: 'exact', head: true })
            .lt('data_limite', today).neq('status', 'CONCLUIDA'),
          supabase.from('tarefas').select('id', { count: 'exact', head: true })
            .eq('data_limite', today).neq('status', 'CONCLUIDA'),
        ])
        if (cancelled) return
        if (projetos.error || atrasadas.error || hoje.error) {
          setStats({ projetos: 0, atrasadas: 0, hoje: 0 })
          return
        }
        setStats({
          projetos: projetos.count ?? 0,
          atrasadas: atrasadas.count ?? 0,
          hoje: hoje.count ?? 0,
        })
      } catch {
        if (!cancelled) setStats({ projetos: 0, atrasadas: 0, hoje: 0 })
      }
    }
    load()
    return () => { cancelled = true }
  }, [])

  return stats
}
